import EmptyMessage from "./EmptyMessage";
import Skeleton from "./Skeleton";
import Styles from "./OddsUnavailable.module.scss";

const OddsUnavailable = () => (
  <div className={Styles.container}>
    <Skeleton />
    <EmptyMessage />
  </div>
);

export default OddsUnavailable;
